import { render } from "./EditVariable.vue?vue&type=template&id=f5c5bb96&scoped=true&ts=true"
import script from "./EditVariable.vue?vue&type=script&lang=ts"
export * from "./EditVariable.vue?vue&type=script&lang=ts"

import "./EditVariable.vue?vue&type=style&index=0&id=f5c5bb96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c5bb96"]])

export default __exports__